export function SmoothScroll(target, speed, smooth) {
  if (target === document)
    target =
      document.scrollingElement ||
      document.documentElement ||
      document.body.parentNode ||
      document.body // cross browser support for document scrolling

  var moving = false
  var pos = target.scrollTop
  var frame =
    target === document.body && document.documentElement
      ? document.documentElement
      : target // safari is the new IE

  target.addEventListener('mousewheel', scrolled, { passive: false })
  target.addEventListener('DOMMouseScroll', scrolled, { passive: false })

  window.addEventListener(
    'scroll',
    () => {
      if (!moving) {
        pos = window.scrollY
      }
    },
    { passive: false }
  )

  function scrolled(e) {
    e.preventDefault() // disable default scrolling

    var delta = normalizeWheelDelta(e)
    pos += -delta * speed
    pos = Math.max(0, Math.min(pos, target.scrollHeight - frame.clientHeight)) // limit scrolling

    if (!moving) update()
  }

  function normalizeWheelDelta(e) {
    if (e.detail) {
      if (e.wheelDelta)
        return (e.wheelDelta / e.detail / 40) * (e.detail > 0 ? 1 : -1)
      // Opera
      else return -e.detail / 3 // Firefox
    } else return e.wheelDelta / 120 // IE,Safari,Chrome
  }

  let previousDelta = 0.0
  function update() {
    moving = true

    var delta = (pos - target.scrollTop) / smooth

    target.scrollTop += delta

    if (delta == 0 || delta == previousDelta) {
      target.scrollBy({
        top: delta,
        behavior: 'smooth',
      })
      moving = false
    } else {
      requestFrame(update)
    }
    previousDelta = delta
  }

  var requestFrame = (function() {
    // requestAnimationFrame cross browser
    return (
      window.requestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.oRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function(func) {
        window.setTimeout(func, 1000 / 50)
      }
    )
  })()
}

export const isMobile = () =>
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  )



// WEBPACK FOOTER //
// ./src/helpers.js